// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0cb271b6","239":"b2f407a5","453":"8348bc57","455":"203027b8"}[chunkId] + ".chunk.js";
};